import React from "react";
import { Component, Fragment } from "react";
import {
	Progress,
	Card,
	CardBody,
  CardTitle,
	Input,
	Row,
	Col,
	Button,
	ListGroup,
	ListGroupItem,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	ButtonDropdown
} from 'reactstrap';

import {
	CenteredBlackDropdown
} from '../../mobile-vitals-dashboard';

import img1 from '../../../assets/images/background/active-bg.png';
import Moment from 'moment';
import { DASHBOARD_POLL_INTERVAL_MS } from '../../dashboard/product-filter';
import DashboardCardLoader from '../../dashboard/dashboard-card-loader';
var moment = require('moment-timezone');

class TopProceduresCatNova extends React.Component {

	noResults = true;
	intervalID = 0;
	pollingIntervalID = 1;
	dataRequestID = 0;

	constructor(props) {
    super(props);
    this.state = {
			rSelected: 2,
			topProcedures: [],
			noDevices: false,
			noDataForDevices: false,
			currentDataSetting: 0,
			startDate: Moment().subtract(3, 'year').format('YYYY-MM-DD'),
			endDate: Moment().format('YYYY-MM-DD'),
			currentDate: Moment().format('YYYY-MM-DD'),
			isOpen: false,
			currentItem: "Global",
			colors: [{color:'warning'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'cyan'}, {color:'warning'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'cyan'}],
			ratioRange: 100,
      procedureList: [
				{ label: "Non Surgical", value: 1 },
        { label: "Surgical", value: 2 },
        { label: "Hygiene", value: 4 },
        { label: "Orthodontics", value: 5 },
      ],
			isLoading: true
	  };

		this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
		this.toggleDropDown = this.toggleDropDown.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
  }

	async componentDidMount() {
		this.intervalID = setInterval(this.checkDeviceId, 1000);
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.currentDevice !== this.props.currentDevice ||
			prevProps.authToken !== this.props.authToken ||
			prevProps.product !== this.props.product
		) {
			clearInterval(this.pollingIntervalID);
			this.setState({
				topProcedures: [],
				noDataForDevices: false,
				ratioRange: 100
			}, () => {
				if (this.props.currentDevice) {
					setTimeout(()=>{ this.getData(this.state.rSelected); }, this.props.loadDelay || 0);
					this.pollingIntervalID = setInterval(()=>{ this.getData(this.state.rSelected); }, DASHBOARD_POLL_INTERVAL_MS);
				}
			});
		}
	}

	toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	handleChange(event) {
		if (event.target.getAttribute('name') == 'startDate') {
			this.setState({startDate: event.target.value});
			this.setState({
	      currentItem: "Custom Range",
				currentDataSetting: 3,
				isLoading: true,
				topProcedures: []
	    });
		} else if (event.target.getAttribute('name') == 'endDate') {
			//console.log('this.state.code: ' + event.target.value);
			this.setState({endDate: event.target.value});
			this.setState({
				currentItem: "Custom Range",
				currentDataSetting: 3,
				isLoading: true,
				topProcedures: []
	    });
		}

		setTimeout(()=>{ this.getData(this.state.rSelected); }, 1000);
  }

	handleSubmit(event) {

		this.getData(this.state.rSelected);
  }

	selectDropDownItem(id, title) {

    this.setState({
      currentItem: title,
			currentDataSetting: id,
			isLoading: true,
			topProcedures: []
    });

		if (id==1) {
			this.setState({ startDate: Moment().subtract(1, 'week').format('YYYY-MM-DD') });
		} else if (id==2) {
			this.setState({ startDate: Moment().subtract(1, 'month').format('YYYY-MM-DD') });
		}

		this.setState({ endDate: Moment().format('YYYY-MM-DD') });

		setTimeout(()=>{ this.getData(this.state.rSelected); }, 1000);
  }

	stepBack () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}

		setTimeout(()=>{ this.getData(this.state.rSelected); }, 1000);
	}

	stepForward () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}

		setTimeout(()=>{ this.getData(this.state.rSelected); }, 1000);
	}

	componentWillUnmount() {
		//console.log("Vitals TopProceduresCat componentWillUnmount");
		clearInterval(this.intervalID);
		clearInterval(this.pollingIntervalID);
	}

	checkDeviceId = () => {
		const {currentDevice} = this.props;
		//console.log("currentDevice: "+currentDevice);

		if (currentDevice) {
			clearInterval(this.intervalID);
			//this.getData(this.state.rSelected);
			setTimeout(()=>{ this.getData(this.state.rSelected); }, this.props.loadDelay || 0);
			this.pollingIntervalID = setInterval(()=>{ this.getData(this.state.rSelected); }, DASHBOARD_POLL_INTERVAL_MS);
		}
  }

	async onRadioBtnClick(rSelected) {
		await this.setState({ rSelected });
		await this.getData(rSelected);
	}

	getData = async category => {

		const requestID = ++this.dataRequestID;
		this.setState({ isLoading: true });
		var timezone = Moment.tz.guess();

		if (this.state.currentDataSetting==0) {
			var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"top-procedures-by-category-for-device?ProductID=2&SerialNumber="+this.props.currentDevice+"&CategoryId="+category;

			var token = "";

			if (this.props.authToken) {
				console.log("laser-usage this.props.authToken: " + this.props.authToken);
				token = this.props.authToken;
			}

			try {
				const response = await fetch(url, {
					method: 'GET',
					headers: {
						Authorization: token
					},
				});

				const body = await response.json();
				console.log("topproceduresbycategoryfordevice: " + JSON.stringify(body));
				if (requestID !== this.dataRequestID) {
					return;
				}

				if (body.status == 'Success') {

					if (body.results.length > 0) {
						var largest = 100;
						for (var i=0; i < body.results.length; i++) {
							if (body.results[i].total > largest) {
								largest = body.results[i].total;
							}
						}
						this.setState({ topProcedures: body.results }, () => console.log(this.state.topProcedures));
						this.setState({
							noDataForDevices: false,
							ratioRange: 2*largest
						});
					} else {
						this.setState({
							noDataForDevices: true
						});
					}
					//this.forceUpdate();
				} else {
					this.setState({
						noDataForDevices: true
					});
				}
			}
			catch (err) {
				console.log(err);
			}
			finally {
				if (requestID === this.dataRequestID) {
					this.setState({ isLoading: false });
				}
			}

		} else {
			var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"top-procedures-by-category-for-device-date-range?ProductID=2&SerialNumber="+this.props.currentDevice+"&CategoryId="+category+"&StartDate="+this.state.startDate+"&EndDate="+this.state.endDate+"&Timezone="+timezone;

			var token = "";

			if (this.props.authToken) {
				console.log("laser-usage this.props.authToken: " + this.props.authToken);
				token = this.props.authToken;
			}

			try {
				const response = await fetch(url, {
					method: 'GET',
					headers: {
						Authorization: token
					},
				});

				const body = await response.json();
				//console.log("topproceduresbycategoryfordevice: " + JSON.stringify(body));
				if (requestID !== this.dataRequestID) {
					return;
				}

				if (body.status == 'Success') {

					if (body.results.length > 0) {
						var largest = 100;
						for (var i=0; i < body.results.length; i++) {
							if (body.results[i].total > largest) {
								largest = body.results[i].total;
							}
						}
						this.setState({ topProcedures: body.results }, () => console.log(this.state.topProcedures));
						this.setState({
							noDataForDevices: false,
							ratioRange: 2*largest
						});
					} else {
						this.setState({
							noDataForDevices: true
						});
					}
					//this.forceUpdate();
				} else {
					this.setState({
						noDataForDevices: true
					});
				}
			}
			catch (err) {
				console.log(err);
			}
			finally {
				if (requestID === this.dataRequestID) {
					this.setState({ isLoading: false });
				}
			}

		}

	};

	getColor(presetID) {

		var color = "success";

		if (presetID>=1 && presetID<=5) {
			color = "success";
		} else if (presetID>=11 && presetID<=19) {
			color = "info";
		} else if (presetID>=21 && presetID<=23) {
			color = "yellow";
		}

		return color;

	}

	render() {

    const opts: DropdownOption[] = [
          { label: "Alpha", value: "a" },
          { label: "Beta", value: "b" },
          { label: "Gamma", value: "c" },
          ];
		const cardMinHeight = this.props.cardMinHeight || 650;
		const contentHeight = this.props.contentHeight || 407;
		const navContentHeight = this.props.navContentHeight || 411;
		const contentOverflowX = this.props.contentOverflowX || 'visible';
		const contentOverflowY = this.props.contentOverflowY || 'visible';
		const contentScrollClassName = this.props.contentScrollClassName || '';

		return (
			/*--------------------------------------------------------------------------------*/
			/* Used In Dashboard-1 [Classic]                                                  */
			/*--------------------------------------------------------------------------------*/
			<Card className="card-hover">
				<CardBody style={{ minHeight: cardMinHeight }}>
					<Row>
						<Col xs="7" md="7" lg="7" className="text-left">
							<CardTitle>Top Procedures by Category Nova</CardTitle>
						</Col>
						<Col xs="5" md="5" lg="5" className="text-right">
							<ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggleDropDown}>
								<DropdownToggle color="dark" caret>
									{this.state.currentItem}
								</DropdownToggle>
								<DropdownMenu right>
									<DropdownItem onClick={() => this.selectDropDownItem(0, 'Global')}>Global</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(1, 'By Week')}>By Week</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(2, 'By Month')}>By Month</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(3, 'Custom Range')}>Custom Range</DropdownItem>
								</DropdownMenu>
							</ButtonDropdown>
						</Col>
					</Row>
          <Row>
						<Col xs="12" md="12" lg="12" className="pt-2 pb-2">
              <CenteredBlackDropdown
                options={this.state.procedureList}
                value={this.state.rSelected}
                onChange={(v) => this.onRadioBtnClick(v)}
                placeholder="Select Category"
                />
						</Col>
					</Row>
					{this.state.noDevices ? (
						<div className="mt-5 text-center">
							<h5>User has no devices</h5>
						</div>
					) : (
						<Fragment>
						{this.state.currentDataSetting == 0 || this.state.currentDataSetting == 3 ? (
							<Fragment>
							<div className={"ml-auto mt-1 "+contentScrollClassName} style={{height: contentHeight, overflowX: contentOverflowX, overflowY: contentOverflowY}}>
									{this.state.isLoading ? (
										<DashboardCardLoader />
									) : this.state.noDataForDevices ? (
										<div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
											<h5>No data for user's devices</h5>
										</div>
									) : (
										<div className="pt-3">
											{this.state.topProcedures.map((procedure, i) => (
												<Fragment>
												<Row key={i}>
													<Col xs="4" md="4" lg="4" className="text-left">
														<span>{procedure.total}</span>
													</Col>
													<Col xs="8" md="8" lg="8" className="text-right">
														<span>{procedure.name}</span>
													</Col>
												</Row>
												<Progress multi className="mt-2 mb-3">
													<Progress bar color="primary" value={(procedure.total/this.state.ratioRange)*100} />
												</Progress>
												</Fragment>
											))}
										</div>
									)}
							</div>
							{this.state.currentDataSetting != 0 &&
								<Fragment>
								<Row className="pt-5 mt-5">
									<Col lg="12" xl="6" className="text-right">
										<div className="float-left" style={{ minWidth: '10%' }}>
											<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
										</div>
										<div className="float-left ml-1" style={{ minWidth: '75%' }}>
											<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
										</div>
									</Col>
									<Col lg="12" xl="6" className="">
										<div className="float-left text-right" style={{ minWidth: '10%' }}>
											<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
										</div>
										<div className="float-left ml-1" style={{ minWidth: '75%' }}>
											<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
										</div>
										{
											// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
											// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Go" disabled={this.state.currentDataSetting != 3}>
											// 	GO
											// </Button>
											// </div>
										}
									</Col>
								</Row>
								</Fragment>
							}
							</Fragment>
						) : (
							<Fragment>
							<Row className={"align-items-center "+contentScrollClassName} style={{height: navContentHeight, overflowX: contentOverflowX, overflowY: contentOverflowY}}>
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" onClick={() => this.stepBack()} title="Step Back">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-left mdi-24px"/>
									</Button>
								</div>
								<div style={{ width: '80%', margin: '0 auto', height: '100%' }}>
									<div className="ml-4 mt-3">
											{this.state.isLoading ? (
												<DashboardCardLoader />
											) : this.state.noDataForDevices ? (
												<div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
													<h5>No data for user's devices</h5>
												</div>
											) : (
												<div className="pt-3">
													{this.state.topProcedures.map((procedure, i) => (
														<Fragment>
														<Row key={i}>
															<Col xs="4" md="4" lg="4" className="text-left">
																<span>{procedure.total}</span>
															</Col>
															<Col xs="8" md="8" lg="8" className="text-right">
																<span>{procedure.name}</span>
															</Col>
														</Row>
														<Progress multi className="mt-2 mb-3">
															<Progress bar color="primary" value={(procedure.total/this.state.ratioRange)*100} />
														</Progress>
														</Fragment>
													))}
												</div>
											)}
									</div>
								</div>
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" disabled={this.state.currentDate==this.state.endDate} onClick={() => this.stepForward()} title="Step Forward">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-right mdi-24px"/>
									</Button>
								</div>
							</Row>
							<Row className="pt-5 mt-5">
								<Col lg="12" xl="6" className="text-right">
									<div className="float-left" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
									</div>
								</Col>
								<Col lg="12" xl="6" className="">
									<div className="float-left text-right" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
									</div>
									{
										// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
										// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Go">
										// 	GO
										// </Button>
										// </div>
									}
								</Col>
							</Row>
							</Fragment>
						)}
						</Fragment>
					)}
				</CardBody>
			</Card>

		);
	}
}

export default TopProceduresCatNova;
